import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface SessionConflictModalProps {
    onClose: () => void;
}

export const SessionConflictModal: React.FC<SessionConflictModalProps> = ({ onClose }) => (
    <ModalWrapper onClose={onClose} borderColor="#ef4444">
        <div style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <AlertCircle size={32} color="#ef4444" />
        </div>
        <h2 style={{ ...UI.text.title, fontSize: 18, margin: "0 0 10px" }}>CONFLICT DETECTED</h2>
        <p style={{ fontSize: '13px', color: '#888', margin: '0 0 25px' }}>A mission is already active. Please finish or abandon the current activity before starting a new one.</p>
        <button onClick={onClose} style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', backgroundColor: '#ef4444', color: '#fff', fontWeight: '900', fontSize: '12px', textTransform: 'uppercase' }}>Acknowledged</button>
    </ModalWrapper>
);
